/**
 * Labstep
 *
 * @module components/Metadata/Form/ShowEdit/InputOutput
 * @desc Metadata field type input/output
 */

import { EntityFormShowEditInputOutput as EntityActionUpdateDropdownPill } from 'labstep-web/components/Entity/Form/ShowEdit/InputOutput';
import type React from 'react';
import type { MetadataFormShowEditInputOutputProps } from './types';

export const MetadataFormShowEditInputOutput: React.FC<
  MetadataFormShowEditInputOutputProps
> = ({ metadata }) => (
  <EntityActionUpdateDropdownPill entity={metadata} />
);
